import React, {Component, Fragment} from 'react';
import {Checkbox, Button, Form, Table, InputNumber, DatePicker} from 'antd';
import moment from 'moment';
import ApiService from '../../actions/apiService';
import CashManagementModal from "./cashManagementModal";
const FormItem = Form.Item;

const data = [{
    key: '1',
    date: '01/01/2010',
    amount: 500,
    isInterest: true,
}, {
    key: '2',
    date: '01/01/2010',
    amount: 500,
    isInterest: false,
}];


class CashManagementPage extends Component {

    state: State = {
        visible: false,
        item: "" ,
        data: data,
    }
    async componentWillMount() {
      const data = {
        Account: 'all'
      };
      const response = await ApiService.getMethod('/account/cash/list', data);
    }

    showAccountModal = (item) => {
        this.setState({
            visible: true,
            item: item
        })
    }

    hideAccountModal = () => {
        this.setState({
            visible: false,
            item: null,
        })
    }
  
    onEdit = (editIndex) => {
        const editObj = this.state.data[editIndex];
        this.setState({
           editIndex,
           editObj
        });
    }
  
  onCancel = () => {
    this.setState({
      editIndex: null,
      editObj: null
    });
  }
  
  onSave = () => {
    const {editObj, data, editIndex} = this.state;
    data[editIndex] = editObj;
    this.setState({
      tranObj: null, data, editIndex: null,
    });
  }
  
  onChangeValues = (name, value) => {
    const {editObj} = this.state;
    this.setState({
      editObj: {
        ...editObj,
        [name]: value
      }
    });
  }

    getColumns = () => {
            const {editIndex, editObj} = this.state;
         return [{
                title: 'Date',
                dataIndex: 'date',
                key: 'date',
                width: '25%',
                render: (text, record, index) => {
                     if (editIndex === index) {
                       return <DatePicker value={editObj.date ? moment(editObj.date) : ''}
                                          onChange={(e, string) => this.onChangeValues('date', string)}/>;
                     } else {
                       return text ? moment(text).format('YYYY-MM-DD') : ''
                     }
                }
            }, {
                title: 'Amount',
                dataIndex: 'amount',
                key: 'amount',
                width: '25%',
               render: (text, record, index) => {
                 if (editIndex === index) {
                   return <InputNumber value={editObj.amount}
                                       onChange={(e) => this.onChangeValues('amount', e)}/>;
                 } else {
                   return text
                 }
               }
            }, {
                title: 'Interest?',
                dataIndex: 'isInterest',
                key: 'isInterest',
                width: '25%',
                render: (text, record, index) => {
                 if (editIndex === index) {
                   return <Checkbox checked={!!editObj.isInterest}
                                 onChange={(e) => this.onChangeValues('isInterest', e.target.checked)}
                                 style={{width: 100}}/>;
                 } else {
                   return text ? 'Yes' : 'No'
                 }
               }
            }, {
                title: 'Action',
                key: 'action',
                render: (text, record, index) => {
                 if (editIndex === index) {
                   return <span><Button onClick={() => this.onSave(index)}>Save</Button><Button
                     onClick={() => this.onCancel(index)}>Cancel</Button></span>
                 } else {
                   return <span><Button onClick={() => this.onEdit(index)}>Edit</Button><Button
                     onClick={() => this.onDelete(index)}>Delete</Button></span>
                 }
               }
            }]
    }

    render() {
        const { visible } = this.state

        const columns = this.getColumns()
        return (
            <div>
                <Button onClick={this.showAccountModal}>New</Button>
                <Table columns={columns} dataSource={data} size="small" />
                {visible && <CashManagementModal visible={visible}  hideAccountModal={this.hideAccountModal} />}
            </div>
        )
    }
}

export default CashManagementPage





// WEBPACK FOOTER //
// ./src/components/setup-and-settings/cashManagementPage.js